// @ts-nocheck
import { createRouter, createWebHashHistory  } from 'vue-router'
import HomePage from '../components/HomePage.vue'
import AdminDashboard from '../components/admin/AdminDashboard.vue'
import WordRoute from '../components/admin/word/WordRoute.vue'
import WordUpdate from '../components/admin/word/WordUpdate.vue'
import AlimentationUpdate from '../components/suivi/SuiviAlimentation.vue'
import EnfantCreate from '../components/enfant/EnfantPage.vue'

const routes = [
	{
	  path: '/',
	  name: 'home',
	  component: HomePage
	},
	{
	  path: '/alimentation',
	  name: 'alimentation',
	  component: AlimentationUpdate
	},
	{
	  path: '/enfant',
	  name: 'enfant',
	  component: EnfantCreate
	},
	{
	  path: '/admin',
	  name: 'admin',
	  component: AdminDashboard,
	  children: [
			{
				path: 'word',
				name: 'admin.word',
				component: WordRoute,
				children: [
					{
						path: 'update',
						name: 'admin.word.update',
						component: WordUpdate,
					},
				]
			}
	  ]
	}, 
]

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
})

export default router